export default __webpack_public_path__ + "static/media/pic-3.1ef1ecba.png";